import script from "./edit-estimate.vue?vue&type=script&setup=true&lang=js"
export * from "./edit-estimate.vue?vue&type=script&setup=true&lang=js"

import "./edit-estimate.vue?vue&type=style&index=0&id=135fd268&lang=css"

const __exports__ = script;

export default __exports__